import { Injectable } from "@angular/core"
import { environment } from "@environments/environment"
import { ApiService } from "./api.service"
import { WindowService } from "./window.service"

@Injectable()
export class LoginHandoffService {
    constructor(
        private apiService: ApiService,
        private windowService: WindowService
    ) {}

    public openLegacyInNewTab(): Promise<void> {
        const targetWindow = this.windowService.window.open(
            "about:blank",
            "_blank"
        )

        if (targetWindow == null) {
            return Promise.reject(
                new Error("Please allow pop-ups to open AIVA 1.0.")
            )
        }

        targetWindow.opener = null

        return this.createHandoffURL()
            .then(url => targetWindow.location.replace(url))
            .catch(error => {
                targetWindow.close()
                throw error
            })
    }

    public async openLegacyInSameTab(): Promise<void> {
        const url = await this.createHandoffURL()
        this.windowService.window.open(url, "_self")
    }

    private async createHandoffURL(): Promise<string> {
        const response = await this.apiService.authRequest(
            "/user/loginHandoff",
            {},
            "primary",
            false
        )

        if (typeof response?.code !== "string" || response.code.length === 0) {
            throw new Error("AIVA 1.0 could not be opened. Please try again.")
        }

        return `${
            environment.legacyDomain
        }/auth/handoff#code=${encodeURIComponent(response.code)}`
    }
}
